import { transparent } from "material-ui/styles/colors";

const drawerWidth = 240;

export const commonStyles = theme => ({
    actionButton: {
        margin: '1vw',
        fontSize: '13px',
        marginLeft: '1vw',
        fontWeight: 'bold',
        cursor: 'pointer',
        color: theme.palette.blue
    },
    searchInput: {
        fontSize: '13px',
        height: '30px',
        boxSizing: 'border-box',
        padding: '0px !important',
        width: '15vw'
    },
    userSearchInput: {
        fontSize: '13px',
        height: '35px',
        boxSizing: 'border-box',
        padding: '0px !important',
        width: '10vw'
    },
    kbSearchInput: {
        fontSize: '13px',
        height: '30px',
        boxSizing: 'border-box',
        padding: '0px !important',
    },
    searchMenu: {
        width: '13vw',
    },
    searchFilter: {
        display: 'flex',
        justifyContent: 'space-between',
    },
    verticalAlign: {
        justifyContent: 'center',
        flexDirection: 'column',
        display: 'flex'
    },
    imgContainer: {
        width: '4vw',
        height: '8vh',
        borderRadius: '8px',
        display: 'flex',
        flexDirection: 'column',
        justifyContent: 'center',
        marginRight: '4px',
        position: 'relative',
        backgroundRepeat: 'no-repeat',
        backgroundSize: 'cover'
    },
    img: {
        width: '8vh',
        color: theme.palette.white,
        display: 'flex',
        maxHeight: '3vh',
        flexDirection: 'column',
        justifyContent: 'space-evenly',
        cursor: 'pointer',
        borderRadius: '8px',
    },
    fileContainer: {
        height: '8vh',
        backgroundColor: theme.palette.silver,
        borderRadius: '8px',
        display: 'flex',
        flexDirection: 'column',
        justifyContent: 'center',
        marginRight: '4px',
        position: 'relative',
        width: '65px',
    },
    fileDiv: {
        backgroundColor: theme.palette.tempBlue,
        width: '125px',
        display: 'flex',
        maxHeight: '75px',
        flexDirection: 'column',
        justifyContent: 'space-evenly',
        cursor: 'pointer',
        borderRadius: '8px',
        fontSize: '13px',
        textOverflow: 'ellipsis',
        overflow: 'hidden',
        whiteSpace: 'nowrap'
    },

    previewContainer: {
        maxWidth: '44vw',
        overflowX: 'scroll',
        display: 'flex'
    },
    closeIcon: {
        position: 'absolute',
        top: '0',
        right: '0'
    },

    filters: {
        textAlign: 'left',
        cursor: 'pointer',
        color: theme.palette.slateGray,
        height: '30px',
        paddingTop: '4px',
        paddingLeft: '1vw',
        fontSize: '13px',
        paddingRight: '1vw',
        '&:hover': {
            color: theme.palette.blue
        }
    },
    selectedFilter: {
        color: theme.palette.blue
    },
    normalHeading: {
        fontSize: '13px',
        fontWeight: 'bold',
        color: theme.palette.primaryGray,
        marginBottom: '1vh'
    },
    preferenceList: {
        display: 'flex',
        justifyContent: 'space-between',
        width: '12vw',
        paddingTop: '4px',
        paddingLeft: '1vw',
        fontSize: '13px',
        paddingRight: '2vw',
        color: theme.palette.slateGray,
    },
    menuItem: {
        backgroundColor: theme.palette.paleGray,
        transitionDuration: '0s !important',

    },
    prefLabel: {
        fontSize: '13px',
        display: 'flex',
        color: theme.palette.warmGray,
        margin: '0vh 1vw',
        cursor: 'pointer'
    },
    filterHeading: {
        fontSize: '13px',
        margin: '2vh 1vw'
    },
    actionContainer: {
        display: 'flex',
        justifyContent: 'flex-end',
        width: '13vw'
    },
    listItem: {
        fontSize: '13PX',
        display: 'flex',
        flexDirection: 'column',
        justifyContent: 'center',
        '&:hover': {
            backgroundColor: 'none'
        }
    },
    switch: {
        height: '5px'
    },
    toggleList: {
        margin: '0vh -2vw',
        backgroundColor: theme.palette.white,
        paddingLeft: '2vw'
    },
    recentSearches: {
        display: 'flex',
        justifyContent: 'space-between',
        marginTop: '2vh'
    },

    align: {
        display: 'flex',
        flexDirection: 'column',
        justifyContent: 'center'
    },
    loadingContainer: {
        display: 'flex',
        justifyContent: 'center',
        flexDirection: 'column',
        height: '80%',
        width: '100%'
    },
    loading: {
        display: 'flex',
        justifyContent: 'center',
    },
    searchBackdrop: {
        backgroundColor: theme.palette.paleGrayFour,
        width: '20vw',
        border: 'none',
        '&:hover': {
            backgroundColor: `${theme.palette.paleGrayFour} !important`
        },
        '&:focus': {
            backgroundColor: `${theme.palette.paleGrayFour} !important`
        }
    },
    kbSearchBackdrop: {
        backgroundColor: theme.palette.paleGrayFour,
        border: 'none',
        '&:hover': {
            backgroundColor: `${theme.palette.paleGrayFour} !important`
        },
        '&:focus': {
            backgroundColor: `${theme.palette.paleGrayFour} !important`
        }
    },
    userSearchBackdrop: {
        backgroundColor: theme.palette.paleGrayFour,
        width: '13vw',
        border: 'none'
    }
})

export const snackbarStyles = theme => ({
    success: {
        backgroundColor: theme.palette.turquoise
    },
    info: {
        backgroundColor: 'black',
        color: 'white'
    },
    error: {
        backgroundColor: theme.palette.red
    }
})

export const headerStyles = theme => ({
    messageCount: {
        marginLeft: '1vw',
        width: '18px',
        height: '14px',
        borderRadius: '40px',
        color: theme.palette.white,
        backgroundColor: theme.palette.blue
    },
    chatList: {
        display: 'flex',
        height: '55px',
        marginTop: '-8PX',
        marginLeft: '8px'
    },
    chat: {
        fontSize: '13px',
        textAlign: 'center',
        width: '10vw',
        color: theme.palette.black,
        cursor: 'pointer',
        display: 'flex',
        justifyContent: 'center',
        flexDirection: 'column',

    },
    activeChat: {
        backgroundColor: theme.palette.dullGray2,
        boxShadow: '1px 0 10px 0 rgba(191, 197, 210, 0.1)',
        color: theme.palette.blue,
        borderBottom: `solid 2px ${theme.palette.blue}`,
        fontWeight: 'bold'
    },
    logo: {
        width: '21vw',
        display: 'flex',
        justifyContent: 'center',
        flexDirection: 'column',
        height: '100%',
        cursor: 'pointer'
    },
    root: {
        position: 'absolute',
        top: '0%',
        left: '0%'
    },
    menuItems: {
        fontSize: '13px'
    },
    menuButton: {
        marginRight: 36,
    },
    hide: {
        display: 'none',
    },
    appBar: {
        backgroundColor: theme.palette.white,
        padding: '0',
        boxShadow: '2px 0 6px 6px rgba(191, 197, 210, 0.1)',
        height: '55px',
    },
    toolbar: {
        height: '55px',
        paddingLeft: '5vw',
    },

    appBarShift: {
        marginLeft: drawerWidth,
        width: `calc(100% - ${drawerWidth}px)`,
        transition: theme.transitions.create(['width', 'margin'], {
            easing: theme.transitions.easing.sharp,
            duration: theme.transitions.duration.enteringScreen,
        }),
    },
    headerContainer: {
        display: 'flex',
        justifyContent: 'space-between'
    }
})

export const sidebarStyles = theme => ({
    burgerIcon: {
        cursor: 'pointer'
    },
    drawer: {
        width: drawerWidth,
        flexShrink: 0,
        whiteSpace: 'nowrap',
        boxShadow: '0 2px 4px 0 rgba(191, 197, 210, 0.6)',
        backgroundColor: theme.palette.white
    },
    drawerOpen: {
        width: drawerWidth,
        transition: theme.transitions.create('width', {
            easing: theme.transitions.easing.sharp,
            duration: theme.transitions.duration.enteringScreen,
        }),

    },
    drawerClose: {
        transition: theme.transitions.create('width', {
            easing: theme.transitions.easing.sharp,
            duration: theme.transitions.duration.leavingScreen,
        }),
        overflowX: 'hidden',
        [theme.breakpoints.up('sm')]: {
            width: theme.spacing(8) + 1,
        },
        backgroundColor: theme.palette.white,
        width: '5%',
        border: 'none',
        boxShadow: '0 2px 4px 0 rgba(191, 197, 210, 0.6)',
    },
    sidebarList: {
        padding: '3vh 0vw'
    },
    listItemText: {
        fontSize: '16px',
        color: theme.palette.primaryGray
    },
    listItem: {
        paddingTop: '3px',
        paddingBottom: '3px',
    },
    activeListItem: {
        backgroundColor: theme.palette.lightBlue
    },
    toolbar: {
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        padding: theme.spacing(0, 1),
        // necessary for content to be below app bar
        ...theme.mixins.toolbar,
    },
    openDrawer: {
        justifyContent: 'space-between'
    },
})

  